/**
  * SUG Tag Manager for handling multiple external Google Tag Manager systems in one location
  * @author SUG
**/

class SugTagManager {
  // TODO: add a constructor method and accept a datalayer property name

  /**
    * Method to handle pushing events to the Data Layers
    * @event - required, name of the event being fired
    * @action - required, action for the event
    * @label - optional, label that provides further detail
    //   example:  pushEvent("myEvent", "myAction", "myLabel");
    //   example:  pushEvent(event = "myEvent", action = "myAction", label = "myLabel");
  **/
  pushEvent = function(event, action, label) {
    if( !window.globalcfg.isEU_User ){
      // UA
      window.ga('send','event', event, action, label);

      // GTM
      window.dataLayer.push({
            'event': event,                    // 'pricing page’
            'eventAction': action,             // 'click'
            'eventLabel': label                // 'gold cta'
      });
    }
  }

  /**
    * Method to handle pushing conversion events to the Data Layer and the Third Party Data Layer
    * @event - required, name of the event being fired
    * @send_to - required, sent to of the event being fired
    * @value - optional, currency amount
    * @currency - optional, currency type
    //   example:  pushConversionEvent("eventNameHere", "AW-877246914/znU2CPbp0okDEMLzpqID");
    //   example:  pushConversionEvent(event = "eventNameHere", sendTo = "AW-877246914/znU2CPbp0okDEMLzpqID", value = 0.00, currency = "USD");
  **/
  pushConversionEvent = function(event, sendTo, value = 0.00, currency = "USD") {
    if( !window.globalcfg.isEU_User ){
      // GTM only, UA is being left as is
      window.dataLayer.push({
                              event: event,
                              send_to: sendTo,
                              value: value,
                              currency: currency
                            });

      // some areas of the site push conversions for older tracking to a thirdPartyDataLayer
      if( typeof window.thirdPartyDataLayer !== 'undefined'){
        window.thirdPartyDataLayer.push(["event","conversion",{
          "send_to": sendTo,
          "value": value,
          "currency": currency
        }]);
      }
    }
  }

  /**
    * Method to handle pushing key / values
    * @key - required, this is the key of the data
    * @value - required, this is the value of the data
    //   example:  pushValue("someKey", "someValue");
    //   example:  pushValue(key = "myKey", value = "myValue");
  **/
  pushValue = function(key, value) {
    if( !window.globalcfg.isEU_User ){
      window.dataLayer.push({[key]: value});
    }
  }

  /**
    * Method to handle reseting the current user Data Layer
  **/
  reset = function() {
    // called when the user logs out from the system

    // GTM only
    window.dataLayer.push(function() {
      this.reset();
    });
  }
}